/* Albisia Sparked parties page: reveal on arrival and smooth in-page links. The party buttons open the booking popup (assets/albisia.js). */
(function () {
  document.querySelectorAll('[data-alb-parties]').forEach(function (sec) {
    if (sec.__albParties) return; sec.__albParties = true;

    var els = sec.querySelectorAll('.alb-reveal');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) { entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      els.forEach(function (el) { io.observe(el); });
    } else { els.forEach(function (el) { el.classList.add('is-in'); }); }

    // Occasion popup: the card button fills the dialog from its hidden content, the dialog's button opens the booking popup
    // with that occasion preselected (assets/albisia.js reads data-party-occasion).
    var modal = sec.querySelector('[data-party-occ-modal]');
    if (modal) {
      var panel = modal.querySelector('.alb-p-modal__panel');
      var last = null;
      var close = function () { modal.hidden = true; document.documentElement.style.overflow = ''; if (last) { try { last.focus(); } catch (e) {} } };
      sec.querySelectorAll('[data-party-occ-open]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var i = btn.getAttribute('data-party-occ-open');
          var src = sec.querySelector('[data-party-occ-content="' + i + '"]');
          var title = btn.getAttribute('data-title') || '';
          modal.querySelector('[data-party-occ-title]').textContent = title;
          modal.querySelector('[data-party-occ-body]').innerHTML = src ? src.innerHTML : '';
          modal.querySelector('[data-party-occ-book]').setAttribute('data-party-occasion', title);
          last = btn; modal.hidden = false; document.documentElement.style.overflow = 'hidden';
          try { panel.focus({ preventScroll: true }); } catch (e) { panel.focus(); }
        });
      });
      modal.querySelectorAll('[data-party-occ-close]').forEach(function (el) { el.addEventListener('click', close); });
      modal.querySelector('[data-party-occ-book]').addEventListener('click', function () { modal.hidden = true; document.documentElement.style.overflow = ''; });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
    }

    sec.querySelectorAll('[data-parties-go]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var target = document.querySelector(a.getAttribute('href'));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  });
})();
